// extracted by mini-css-extract-plugin
module.exports = {"heading":"BottomCTA_heading__BQ0bO"};